import { GoogleTagManager } from '@next/third-parties/google';

import { env } from '../utils';

/**
 * prod 환경이고 KC_GTM_ID가 설정된 경우에만 Google Tag Manager 스크립트를 주입
 */
export default function GTMInitializer() {
  return env.KC_ENV === 'prod' && env.KC_GTM_ID ? <GoogleTagManager gtmId={env.KC_GTM_ID} /> : null;
}
